import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AllocationRule } from '../interfaces/accounting.interface';

export const AllocationRuleService = {
    getGlobalRules: async (): Promise<AllocationRule[]> => {
        const res = await axios.get(ENDPOINTS.ALLOCATION_RULE.BASE);
        return res.data;
    },
    update: async (id: string, rule: AllocationRule): Promise<AllocationRule> => {
        const res = await axios.put(ENDPOINTS.ALLOCATION_RULE.UPDATE(id), rule);
        return res.data;
    },
};
